import React, { PropsWithChildren } from 'react'
import { Typography, Tooltip } from '@mui/material'

export function WithTooltip({ text, children }: PropsWithChildren<{ text?: string }>) {
    return text ?
        (<Tooltip title={<Typography variant='body1'>{text}</Typography>} placement='top'>
            <>{children}</>
        </Tooltip>)
        : (<>{children}</>)
}